<body class="fixed-navbar">
  <app-navbar></app-navbar>
  <!--  -->

  <!-- menu lateral -->
  <app-sidebar></app-sidebar>
  <!--  -->
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</body>

<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" size="medium" color="#fff">
  <p style="color: white">
    {{ (mensagemSpinner$ | async) || 'Carregando...' }}
  </p>
</ngx-spinner>
